(() => {
	const PARAM = 'otros_filtros';
	const HIDDEN_CLASS = 'is-otros-filtro-hidden';

	const getActiveValue = () => {
		const params = new URLSearchParams(window.location.search);
		const custom = params.get(PARAM);
		if (custom) return custom.trim();

		const native = params.get('filter.p.m.custom.otros_filtros');
		if (!native) return '';

		const raw = native.trim();
		if (raw.includes('gid://shopify/Metaobject/')) {
			return raw.split('/').pop() || raw;
		}
		return raw;
	};

	const productMatches = (product, active) => {
		if (!active) return true;
		const tokens = (product.getAttribute('data-otros-filtros') || '')
			.split('|')
			.map((token) => token.trim())
			.filter(Boolean);
		return tokens.includes(active);
	};

	const updateNavState = (active) => {
		const nav = document.querySelector('[data-otros-filtros-nav]');
		if (!nav) return;

		const allLink = nav.querySelector('[data-otros-filtro-all]');
		const links = nav.querySelectorAll('[data-otros-filtro-link]');

		if (allLink) {
			allLink.classList.toggle('active', !active);
		}

		links.forEach((link) => {
			const handle = link.getAttribute('data-otros-filtro-handle') || '';
			const id = link.getAttribute('data-otros-filtro-id') || '';
			const isActive = Boolean(active) && (active === handle || active === id);
			link.classList.toggle('active', isActive);
		});
	};

	const applyFilter = () => {
		const active = getActiveValue();
		const products = document.querySelectorAll(
			'[data-collection-products-grid] .collection-main-product'
		);

		products.forEach((product) => {
			const matches = productMatches(product, active);
			product.classList.toggle(HIDDEN_CLASS, Boolean(active) && !matches);
			product.hidden = Boolean(active) && !matches;
		});

		updateNavState(active);
	};

	document.addEventListener('DOMContentLoaded', applyFilter);
	document.addEventListener('shopify:section:load', applyFilter);

	const grid = document.querySelector('[data-collection-products-grid]');
	if (grid && typeof MutationObserver !== 'undefined') {
		const observer = new MutationObserver(() => applyFilter());
		observer.observe(grid, { childList: true });
	}

	window.applyOtrosFiltrosFilter = applyFilter;
})();
